import { render, staticRenderFns } from "./ProcessInstance.vue?vue&type=template&id=60105bac&scoped=true"
import script from "./ProcessInstance.vue?vue&type=script&lang=js"
export * from "./ProcessInstance.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstance.vue?vue&type=style&index=0&id=60105bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60105bac",
  null
  
)

export default component.exports